<bn-loading-overlay></bn-loading-overlay>

<div class="container">
  <div class="row">
    <h4 class="col">Cálculo do Saldo Devedor</h4>
    <div class="col-auto">
      <button class="btn btn-light" (click)="limpar()">limpar</button>
      <button #botaoCalcular class="btn btn-primary" (click)="calcular()" [disabled]="!formCalculo.valid || !permissaoEnvio">
        Calcular Saldo Devedor
      </button>
    </div>
  </div>
  <div class="alert alert-warning p-1 mt-3" role="alert">
    ⚠️ As cotações da SELIC D-2 (UM 143) estão carregadas até {{ dataUltimaCotacaoSelic }} neste ambiente. Se necessário, 
    solicite à TI a atualização das cotações.
  </div>
  <div class="alert alert-warning p-1 mt-2" role="alert">
    ⚠️ Para operações de Repasse, é sempre apurado o saldo devedor de principal. Operações de Crédito Livre consideram 
    eventuais capitalizações de juros no caso de a modalidade de garantia utilizar taxa de atualização de garantia.  
  </div>
  <form [formGroup]="formCalculo" (keyup.enter)="botaoCalcular.click()">
    <div class="row mt-4">
      <div class="col-md-4 bn-form-group"> 
        <label class="form-label"><b>Id. operação crédito</b></label>
        <input type="text" class="form-control" formControlName="idOperacaoCredito" bnMask="INTEIRO">
      </div>
      <div class="col-md-4 bn-form-group">
        <label class="form-label"><b>Data do Cálculo</b></label>
        <bn-datepicker formControlName="dataCalculo"></bn-datepicker>
      </div>
    </div>
  </form>
  <div class="mt-3" *ngIf="mostrarResultado">
    <div class="row">
      <h4 class="col">Resultado do cálculo</h4>
    </div>
    <div class="row">
      <div class="col-md-3 bn-form-group">
        <label class="form-label"><b>valor do Saldo Devedor</b></label>
        <input type="text" class="form-control" [value]="calculoRetorno.valorSaldoDevedor | bnMask: 'MOEDA'" readonly>
      </div>
    </div>
  </div>
</div>